import { NgModule } from '@angular/core';

import { CordovaService } from './services';

@NgModule({
  providers: [CordovaService],
})
export class CordovaModule {}
